import { EMPTY_STRING } from '@roko/ui/constants/common'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { resources } from '@/translations/locales'

const debugEnv = ['local']
const debug = debugEnv.includes(import.meta.env.VITE_APP_ENV_MODE ?? EMPTY_STRING)

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
  debug,
})

// eslint-disable-next-line no-barrel-files/no-barrel-files
export default i18n
